import { Type } from '@angular/core';
import { checkIfControlIsAlreadyPresentByName } from './helpers';
import { DxFormGroup } from '../form-group';
import { DxFormArray } from '../form-array';
import { FORM_ARRAY_METADATA_KEY } from './metadata-keys';
import { DxFormArrayDefinition } from './interfaces';
import { addToMetadata } from '@digitaix/helpers';

export function FormArray(
  group: Type<DxFormGroup<any, any, any>>,
  array?: Type<DxFormArray<any, any, any>>
) {
  return function(target: any, propertyKey: string) {
    const definition: DxFormArrayDefinition<any> = {
      name: propertyKey,
      propertyKey,
      group,
      array: array || DxFormArray
    };
    if (
      checkIfControlIsAlreadyPresentByName(
        FORM_ARRAY_METADATA_KEY,
        target,
        definition.name
      )
    ) {
      throw new Error(
        `[FormArray::${propertyKey}] A FormArray with name '${
          definition.name
        }' is already defined`
      );
    }
    addToMetadata(FORM_ARRAY_METADATA_KEY, definition, target);
  };
}
